import { render, staticRenderFns } from "./deleteResultButton.vue?vue&type=template&id=94dce428&"
import script from "./deleteResultButton.vue?vue&type=script&lang=js&"
export * from "./deleteResultButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports